import { render, staticRenderFns } from "./AthleteAutocomplete.vue?vue&type=template&id=f1aaa3de&"
import script from "./AthleteAutocomplete.vue?vue&type=script&lang=ts&"
export * from "./AthleteAutocomplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports